// Driver location is stored in users.region as an exact five-digit US ZIP code.
const ZIP_PATTERN = /^[0-9]{5}$/;

export const ZIP_INVALID_MESSAGE = 'Enter a valid US ZIP code.';

// Returns the exact five-digit ZIP, preserving leading zeros, or ''.
export function normalizeZipCode(value) {
    const candidate = String(value || '');
    return candidate.length === 5 && ZIP_PATTERN.test(candidate) ? candidate : '';
}

export function getZipCodeError(value) {
    if (!String(value || '').trim()) return 'Please enter your ZIP code.';
    if (!normalizeZipCode(value)) return ZIP_INVALID_MESSAGE;
    return '';
}
